import classNames from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import { ReactComponent as Arrow } from '@assets/icons/arrow.svg'

import s from './NavAccordion.module.scss'
import { NavAccordionProps } from './NavAccordion.props'

export function NavAccordion({ route }: NavAccordionProps) {
  const linkMargin = 16
  const marginTop = 5
  const linksCount = route.list.filter((i) => !i?.hidden).length

  const { t } = useTranslation()
  const { pathname } = useLocation()

  const [isActive, setIsActive] = useState<boolean>(route.rootPath === pathname.split('/')[1])

  const toggleHandler = () => {
    setIsActive((prev) => !prev)
  }

  return (
    <div className={s.wrapper}>
      <div
        className={s.title}
        onClick={toggleHandler}
      >
        {t(`aside.${route.rootPath}`)}
        <Arrow className={classNames(s.icon, { [s.active]: isActive })} />
      </div>
      <div
        className={classNames(s.panel, { [s.active]: isActive })}
        style={{
          height: isActive ? 25 * linksCount + linkMargin * linksCount + marginTop : 0,
          paddingTop: isActive ? marginTop : 0,
          overflow: isActive ? 'unset' : 'hidden',
        }}
      >
        {route.list.map((i) =>
          !!i?.list?.length ? (
            <div
              key={i.path}
              className={s.listWrapper}
            >
              <span
                className={classNames(s.listTitle, { [s.active]: pathname.includes(`${route.rootPath}/${i.path}`) })}
                style={{ marginBottom: linkMargin + 'px' }}
              >
                {t(`aside.${route.rootPath}.${i.path}`)}
              </span>
              <div className={s.list}>
                {i.list.map((j) => (
                  <NavLink
                    key={j.path}
                    to={`${route.rootPath}/${i.path}/${j.path}`}
                    className={({ isActive }) => classNames(s.link, { [s.active]: isActive })}
                    style={{ marginBottom: linkMargin + 'px' }}
                  >
                    {t(`aside.${route.rootPath}.${i.path}.${j.path}`)}
                  </NavLink>
                ))}
              </div>
            </div>
          ) : (
            !i?.hidden && (
              <NavLink
                key={i.path}
                to={`${route.rootPath}/${i.path}`}
                className={({ isActive }) => classNames(s.link, { [s.active]: isActive })}
                style={{ marginBottom: linkMargin + 'px' }}
              >
                {t(`aside.${route.rootPath}.${i.path}`)}
              </NavLink>
            )
          ),
        )}
      </div>
    </div>
  )
}
